import React, { FC, useEffect } from 'react'

import { colors } from '@smarty-nx/ds'
import { graphql } from 'gatsby'

import CompareGroupPlansCalculator from './compare-group-plans-calculator'
import GroupPlanBenefits from './group-plan-benefits'
import classes from './group-plans.module.scss'
import PageHead from '../../components/PageHead'
import { FullWidthContainer } from '../../components/styles'
import SiteContainer from '../../components/styles/SiteContainer'
import Spacer from '../../components/styles/Spacer'
import TrustPilot from '../../components/TrustPilot'
import withApp, { AppProps } from '../../components/withApp/withApp'
import FaqSection from '../../modular-system/FaqSection'
import { FaqSectionProps } from '../../modular-system/FaqSection/FaqSection'
import { HeroBanner } from '../page-template/page-sections'
import { pageSectionsMapping } from '../page-template/page-sections-mapping'

interface GroupPlansProps {
  data: {
    contentfulPageSection: Queries.GenericPageSectionFragment
    whyChooseGroup: Queries.GenericPageSectionFragment
    groupPlanFAQ: FaqSectionProps
  }
}

const GroupPlans: FC<AppProps & GroupPlansProps> = ({
  fetchGroupPlans,
  data: { contentfulPageSection, whyChooseGroup, groupPlanFAQ },
}) => {
  useEffect(() => {
    fetchGroupPlans({ alwaysWithGroupDiscount: true })
  }, [fetchGroupPlans])

  const type =
    whyChooseGroup.displayContentAs as keyof typeof pageSectionsMapping

  const Component = pageSectionsMapping[type]
  return (
    <div className={classes.groupPlans}>
      <FullWidthContainer background={colors[whyChooseGroup.bg?.theme || '']}>
        <SiteContainer>
          <div className={classes.mainHeader}>
            <HeroBanner index={0} {...contentfulPageSection} />
          </div>
          {Component && (
            <Component index={1} key={whyChooseGroup.id} {...whyChooseGroup} />
          )}
          <CompareGroupPlansCalculator />
          <GroupPlanBenefits />
          <TrustPilot dataTestId="homepage-trustpilot-widget" />
        </SiteContainer>
        <SiteContainer className={classes.faq}>
          <FaqSection {...groupPlanFAQ} />
          <Spacer />
        </SiteContainer>
      </FullWidthContainer>
    </div>
  )
}

export default withApp(GroupPlans)

export const Head = () => (
  <PageHead
    title="Save on every SIM with a Group plan"
    description="Enjoy discounted plans. Save on every SIM you add to your Group. Stay flexible if you change your mind. Save time and money. Thats's SMARTY"
  />
)

export const query = graphql`
  query {
    contentfulPageSection(sectionName: { eq: "group-landing-page-header" }) {
      ...LandingHeaderSection
    }
    whyChooseGroup: contentfulPageSection(
      sectionName: { eq: "why-choose-a-smarty-group" }
    ) {
      ...GenericPageSection
    }
    groupPlanFAQ: contentfulPageSection(
      sectionName: { eq: "group-plan-faq-list" }
    ) {
      ...FaqSection
    }
  }
`
